import { render } from "./picture.vue?vue&type=template&id=f8d25c0c"
import script from "./picture.vue?vue&type=script&lang=js"
export * from "./picture.vue?vue&type=script&lang=js"

import "./picture.vue?vue&type=style&index=0&id=f8d25c0c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__